















































































































import {
  FormItem,
  Select,
  Input,
  Form,
  RadioButton,
  RadioGroup,
  Button,
  Option,
  Loading,
} from 'element-ui'
import { ElLoadingComponent } from 'element-ui/types/loading'
import { Vue, Prop, Component, Ref, Watch } from 'vue-property-decorator'

import Checkbox from '@/components/Checkbox.vue'
import CreditCardInput from '@/components/CreditCardInput.vue'

import CreditCard from '@/models/credit-card'
import Currency from '@/models/currency'
import { MINIMAL_PAYMENT_AMOUNT_CENTS } from '@/models/payment'

import { isIslandHopping } from '@/globalMixin'
import { StripeActionTypes } from '@/store/modules/stripe'

import CreditCardDropdown from './CreditCardDropdown.vue'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [Option.name]: Option,
    CreditCardDropdown,
    Checkbox,
    CreditCardInput,
  },
})
export default class EnrollTabCardPayment extends Vue {
  @Prop() creditCards!: CreditCard[]
  @Prop() total!: number
  @Prop() stripeSdkLoaded!: boolean
  @Prop() paymentBeingProcessed!: boolean
  @Prop() termsAccepted!: boolean
  @Prop(String) currencyCode!: Currency
  @Prop() enrollTabCardInfo!: any
  @Prop() isYachtCharter!: boolean
  @Prop() paymentModalBodyRef!: HTMLElement
  @Ref() readonly enrollFormRef!: Form
  @Ref() readonly creditCardRef!: CreditCardInput

  stripePaymentMethod = ''
  validationInProgress = false
  spinnerService: ElLoadingComponent | null = null

  rules = {
    cardholderName: [
      { required: true, message: 'Cardholder Name is required' },
    ],
    termsAccepted: [
      {
        validator: this.termsAcceptedValidator.bind(this),
      },
    ],
    cardAliasName: [{ required: true, message: 'Card Name is required' }],
    creditCard: [{ validator: this.creditCardValidator.bind(this) }],
  }

  private elementsErrors: string[] = []

  @Watch('paymentBeingProcessed')
  onPaymentBeingProcessed(paymentBeingProcessed: boolean) {
    if (!paymentBeingProcessed) {
      this.stopSpinner()
    }
  }

  beforeDestroy() {
    this.stopSpinner()
  }

  setStripePaymentMethod(paymentMethod: string) {
    this.stripePaymentMethod = paymentMethod
  }

  get creditCardErrors() {
    return [...this.elementsErrors]
  }

  get submitDisabled(): boolean {
    return (
      this.validationInProgress ||
      this.total < MINIMAL_PAYMENT_AMOUNT_CENTS ||
      this.paymentBeingProcessed ||
      !this.termsAccepted
    )
  }

  get showCreditCards() {
    // This feature is temporarily disabled
    return false // this.currencyCode === Currency.GBP || this.isYachtCharter
  }

  get termsLink(): string {
    return isIslandHopping()
      ? 'https://www.island-hopping.com/booking-terms'
      : 'https://www.sail-croatia.com/booking-terms'
  }

  stopSpinner(): void {
    this.$nextTick(() => {
      if (this.spinnerService) {
        this.spinnerService.close()
      }
    })
  }

  termsAcceptedValidator(
    rule: any,
    value: boolean,
    callback: (errors?: string) => void,
  ) {
    if (this.termsAccepted) {
      callback()
    } else {
      callback('You have to agree to the Terms & Conditions')
    }
  }

  async creditCardValidator(
    rule: any,
    value: undefined,
    callback: (errors?: string) => void,
  ) {
    const response = await this.creditCardRef.getStripePaymentMethod(
      this.enrollTabCardInfo.cardholderName,
    )
    if (response.error) {
      callback(response.error.message)
    } else {
      this.setStripePaymentMethod(
        (response.paymentMethod && response.paymentMethod.id) || '',
      )
    }
  }

  onCardError(errors: string[]) {
    this.elementsErrors = errors
  }

  onChoosePaymentMethod(event: Event) {
    this.$emit('on-update-enroll-tab-info', {
      name: 'creditCardId',
      value: event,
    })
  }

  handleEnroll() {
    this.spinnerService = Loading.service({
      target: this.paymentModalBodyRef,
    })
    this.validationInProgress = true
    this.enrollFormRef.validate((valid) => {
      if (valid) {
        this.$emit('on-enroll', this.stripePaymentMethod)
      } else {
        this.spinnerService && this.spinnerService.close()
      }
      this.validationInProgress = false
    })
  }

  created() {
    this.$store.dispatch(StripeActionTypes.LoadSdk, this.isYachtCharter)
  }
}
